<template>
  <div>
    <app-nav :full-name="userFullName" />

    <div class="columns">
      <div class="column"/>
      <div class="column is-three-quarters">

        <!-- report form -->
        <form @submit.prevent="createExcelReport">
          <b-field label="Prepared For">
            <b-input
              v-model="preparedFor"
              name="preparedFor"
              placeholder="Our Awesome Client" />
          </b-field>

          <b-field label="Articles">
            <b-input
              v-model="articles"
              type="textarea"
              name="articles"
              placeholder="One article ID per line" />
          </b-field>

          <div class="field is-grouped">
            <div class="control">
              <button
                class="button is-primary">Create</button>
            </div>
            <div class="control">
              <router-link
                class="button is-danger is-outlined"
                to="/articles">Cancel</router-link>
            </div>
          </div>

        </form>

      </div>
      <div class="column"/>
    </div>

  </div>
</template>

<script>
import AppNav from './AppNav'
import { checkLogin, getUser } from '../utils/auth'
import { createReport } from '../utils/api'
import { downloadContent } from '../utils/http'

export default {
  name: 'report',
  components: {
    AppNav
  },
  data() {
    return {
      // navbar
      userFullName: '',
      // input values
      preparedFor: '',
      articles: ''
    }
  },
  mounted() {
    let self = this
    checkLogin().then(function(loggedIn) {
      if (loggedIn) {
        self.userFullName = JSON.parse(getUser()).fullName
      } else {
        self.$router.push('/login')
      }
    })
  },
  methods: {
    createExcelReport() {
      let self = this

      if (self.preparedFor.trim() === '') {
        self.$toast.open({
          message: 'Please enter a value for "Prepared For"',
          duration: 3000,
          position: 'is-top',
          type: 'is-danger'
        })
        return
      }
      if (self.articles.trim() === '') {
        self.$toast.open({
          message: 'Please enter a value for "Articles"',
          duration: 3000,
          position: 'is-top',
          type: 'is-danger'
        })
        return
      }

      const data = {
        preparedFor: self.preparedFor,
        articles: self.articles
      }

      createReport(data).then((response) => {
        self.$toast.open({
          message: 'Create report succeeded',
          duration: 3000,
          position: 'is-top',
          type: 'is-success'
        })
        downloadContent(response)
      }).catch(function() {
        self.$toast.open({
          message: 'Create report failed',
          duration: 3000,
          position: 'is-top',
          type: 'is-danger'
        })
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Report.vue